import { getSafeGutter, validateGutter, spacing, checkIsCSSLength } from "@bedrock-layout/spacing-constants";
import styled from "styled-components";
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
const validKeys = /* @__PURE__ */ new Set([
  "left",
  "right",
  "top",
  "bottom",
  "inlineStart",
  "inlineEnd",
  "blockStart",
  "blockEnd"
]);
const keyToProperty = (key, val) => {
  const modernMap = {
    left: `padding-inline-start:${val};`,
    right: `padding-inline-end:${val};`,
    top: `padding-block-start:${val};`,
    bottom: `padding-block-end:${val};`,
    inlineStart: `padding-inline-start:${val};`,
    inlineEnd: `padding-inline-end:${val};`,
    blockStart: `padding-block-start:${val};`,
    blockEnd: `padding-block-end:${val};`
  };
  return modernMap[key];
};
const paddingToString = (theme, padding) => {
  var _a;
  if (Array.isArray(padding) && padding.length > 4) {
    throw new Error("padding arrays can only be 4 or less in length");
  }
  const validSpacings = new Set(Object.keys((_a = theme.spacing) != null ? _a : spacing));
  const isValidPadding = () => {
    if (typeof padding === "number" || typeof padding === "string") {
      return padding > 0 || validSpacings.has(padding.toString()) || checkIsCSSLength(padding.toString());
    }
    if (Array.isArray(padding)) {
      return padding.every((val) => {
        return val > 0 || validSpacings.has(val.toString()) || checkIsCSSLength(val.toString());
      });
    }
    return padding !== void 0 && Object.keys(padding).every((key) => validKeys.has(key)) && Object.values(padding).every((val) => {
      return val > 0 || validSpacings.has(val.toString()) || checkIsCSSLength(val.toString());
    });
  };
  if (!isValidPadding()) {
    console.error("Invalid padding Type");
  }
  return typeof padding === "object" && !Array.isArray(padding) ? Object.entries(padding).reduce((acc, [key, val]) => {
    var _a2;
    return acc + keyToProperty(key, (_a2 = getSafeGutter(theme, val)) != null ? _a2 : "0px");
  }, "") : `padding: ${Array.from(Array.isArray(padding) ? padding : [padding]).map((pad) => {
    var _a2;
    return (_a2 = getSafeGutter(theme, pad)) != null ? _a2 : "0px";
  }).join(" ")};`;
};
const PadBox = styled.div.attrs(() => ({
  "data-bedrock-padbox": ""
}))`
  box-sizing: border-box;
  ${(props) => props.padding !== void 0 ? paddingToString(props.theme, props.padding) : ""}
`;
PadBox.displayName = "PadBox";
PadBox.propTypes = {
  padding: PropTypes.oneOfType([
    validateGutter,
    PropTypes.objectOf(validateGutter),
    PropTypes.arrayOf(validateGutter)
  ]).isRequired
};
export { PadBox };
